<div class="backroundMenu">
  <div class="ml-5 mt-4 mb-6 hidden xl:block">
    <p-image src="assets/images/{{regione}}.png" width="200px"></p-image>
  </div>
  <div class="flex justify-content-center">
    <p-panelMenu [model]="sidebarMenu"></p-panelMenu>
  </div>
</div>
